import { createContext } from 'react';
import { type ExternalFile } from '@/lib/types';
import dummyFunction from '@/lib/utils/dummyFunction';

const SelectedFilesContext = createContext<{
  selectedFiles: Map<string, ExternalFile>;
  selectFile: (externalFile: ExternalFile) => void;
  deselectFile: (externalFileUrl: string) => void;
  canSelectMoreFiles: boolean;
}>({
  selectedFiles: new Map(),
  selectFile: dummyFunction,
  deselectFile: dummyFunction,
  canSelectMoreFiles: true,
});

export default SelectedFilesContext;
